import Vue from 'vue';
import Vuex from 'vuex';
import * as i18n from './i18n';
import * as booking from './booking';
import * as guidedBooking from './guidedBooking';
import * as dealConfirmation from './dealConfirmation';
import * as dateAndPrice from './dateAndPrice';
import * as funnel from './funnel';
import checkout from './checkout/index';
import { CheckoutState } from './checkout';

Vue.use(Vuex);

export interface IStore {
    i18n: i18n.IState
    booking: booking.IState
    dealConfirmation: dealConfirmation.IState
    dateAndPrice: dateAndPrice.IState
    checkout: CheckoutState
    funnel: funnel.IState
}

const store = new Vuex.Store<IStore>({
    strict: true,
    modules: {
        i18n,
        booking,
        guidedBooking,
        dealConfirmation,
        dateAndPrice,
        checkout,
        funnel
    }
});

store.dispatch('i18n/init');

export default store;
